import { ReactComponent as ColumnSvg } from '@/commons/icons/new/structure/column.svg';
import { ReactComponent as BeamSvg } from '@/commons/icons/new/structure/beam.svg';
import { ReactComponent as BarSvg } from '@/commons/icons/new/structure/bar.svg';
import { ReactComponent as WallSvg } from '@/commons/icons/new/structure/wall.svg';
import { ReactComponent as FloorSvg } from '@/commons/icons/new/structure/floor.svg';
import { ReactComponent as BraceSvg } from '@/commons/icons/new/structure/brace.svg';
import { ReactComponent as NodePSvg } from '@/commons/icons/new/structure/node-p.svg';
import { ReactComponent as MaterialSvg } from '@/commons/icons/new/material.svg';
import { ReactComponent as SectionSvg } from '@/commons/icons/new/section.svg';
import { SIDE_TYPE } from '@/commons/enums/side-type';
import { SideStatus } from '@/commons/context/side-store';
import { useContext } from 'react';
import { SideContext } from '@/App';
import { graphicStore } from '@/commons/store/graphic-store';
import localStore from '@/commons/store/local-store';
import { MAJOR } from '@/commons/constants/major';
import { STRUCTURE_SUB_CONTROL } from '@/passets/structure-engine/enums/structure-sub-control';
import { STRUCTURE_CTRL_TYPE } from '@/passets/structure-engine/enums/structure-control-type';

import { ReactComponent as ZhuanyecanzhaoSvg } from '@/commons/icons/menu/zhuanyecanzhao.svg';
import { ReactComponent as ZhouxianSvg } from '@/commons/icons/menu/zhouxian.svg';
import { ReactComponent as YinyongloucengSvg } from '@/commons/icons/menu/yinyonglouceng.svg';
import { ReactComponent as YinyongzhouwangSvg } from '@/commons/icons/menu/yinyongzhouwang.svg';

import { ReactComponent as CailiaobiaoSvg } from '@/commons/icons/menu/structure/cailiaobiao.svg';
import { ReactComponent as DianjiedianSvg } from '@/commons/icons/menu/structure/dianjiedian.svg';
import { ReactComponent as ChaxunSvg } from '@/commons/icons/menu/structure/chaxun.svg';
import { ReactComponent as GanSvg } from '@/commons/icons/menu/structure/gan.svg';
import { ReactComponent as GuifanjiaoyanSvg } from '@/commons/icons/menu/structure/guifanjiaoyan.svg';
import { ReactComponent as HanfengSvg } from '@/commons/icons/menu/structure/hanfeng.svg';
import { ReactComponent as HengjiaSvg } from '@/commons/icons/menu/structure/hengjia.svg';
import { ReactComponent as HezaibiaoSvg } from '@/commons/icons/menu/structure/hezaibiao.svg';
import { ReactComponent as HezaigongkuangSvg } from '@/commons/icons/menu/structure/hezaigongkuang.svg';
import { ReactComponent as HezaizuheSvg } from '@/commons/icons/menu/structure/hezaizuhe.svg';

import { ReactComponent as JiajingbanSvg } from '@/commons/icons/menu/structure/jiajingban.svg';
import { ReactComponent as JiehedianSvg } from '@/commons/icons/menu/structure/jiehedian.svg';
import { ReactComponent as JisuanxuanxingSvg } from '@/commons/icons/menu/structure/jisuanxuanxing.svg';
import { ReactComponent as JizhonghezaiSvg } from '@/commons/icons/menu/structure/jizhonghezai.svg';
import { ReactComponent as KuaijiaSvg } from '@/commons/icons/menu/structure/kuaijia.svg';
import { ReactComponent as LingpeijianbiaoSvg } from '@/commons/icons/menu/structure/lingpeijianbiao.svg';
import { ReactComponent as LuoshuanSvg } from '@/commons/icons/menu/structure/luoshuan.svg';
import { ReactComponent as ShanchuSvg } from '@/commons/icons/menu/structure/shanchu.svg';
import { ReactComponent as MaodingSvg } from '@/commons/icons/menu/structure/maoding.svg';
import { ReactComponent as MianhezaiSvg } from '@/commons/icons/menu/structure/mianhezai.svg';

import { ReactComponent as QiujieqixuanxingSvg } from '@/commons/icons/menu/structure/qiujieqixuanxing.svg';
import { ReactComponent as ShengsuoSvg } from '@/commons/icons/menu/structure/shengsuo.svg';
import { ReactComponent as ShuchuSvg } from '@/commons/icons/menu/structure/shuchu.svg';
import { ReactComponent as TianjiaSvg } from '@/commons/icons/menu/structure/tianjia.svg';
import { ReactComponent as WangjiaSvg } from '@/commons/icons/menu/structure/wangjia.svg';
import { ReactComponent as WangkeSvg } from '@/commons/icons/menu/structure/wangke.svg';
import { ReactComponent as XianhezaiSvg } from '@/commons/icons/menu/structure/xianhezai.svg';
import { ReactComponent as XianshiSvg } from '@/commons/icons/menu/structure/xianshi.svg';
import { ReactComponent as YueshuSvg } from '@/commons/icons/menu/structure/yueshu.svg';
import { ReactComponent as ZhichengSvg } from '@/commons/icons/menu/structure/zhicheng.svg';



export default function StructureMenu() {
    const sideContext = useContext<SideStatus>(SideContext);

    const onClick = (route: string, majorUuid?: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
        sideContext.setSelectedMajorUuid(majorUuid);
        localStore.setSelectedMajor(majorUuid);
    }

    const activeCtrl = (name: string, ctrlId: number) => {
        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl
            || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== ctrlId) {
            // 激活二级控制器
            graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl(name);
        }
    }

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongzhouwangSvg /></div>
                                <div className='name'>引用轴网</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhouxianSvg /></div>
                                <div className='name'>轴线</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongloucengSvg /></div>
                                <div className='name'>引用楼层</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhuanyecanzhaoSvg /></div>
                                <div className='name'>专业参照</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><KuaijiaSvg /></div>
                                <div className='name'>框架</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><WangjiaSvg /></div>
                                <div className='name'>网架</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><WangkeSvg /></div>
                                <div className='name'>网壳</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><HengjiaSvg /></div>
                                <div className='name'>桁架</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><JiehedianSvg /></div>
                                <div className='name'>结点</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name1' onClick={() => { onClick(SIDE_TYPE.structure_beam) }}>
                                <div className='icon'><BeamSvg /></div>
                                <div className='name'>梁</div>
                            </div>
                            <div className='ope-item name1' onClick={() => { onClick(SIDE_TYPE.structure_column) }}>
                                <div className='icon'><ColumnSvg /></div>
                                <div className='name'>柱</div>
                            </div>
                            <div className='ope-item name1' onClick={() => { onClick(SIDE_TYPE.structure_bar) }}>
                                <div className='icon'><GanSvg /></div>
                                <div className='name'>杆</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.structure_wall) }}>
                                <div className='icon'><WallSvg /></div>
                                <div className='name'>墙</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.structure_floor) }}>
                                <div className='icon'><FloorSvg /></div>
                                <div className='name'>楼板</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.structure_brace) }}>
                                <div className='icon'><ZhichengSvg /></div>
                                <div className='name'>支撑</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name1 disabled' onClick={() => { }}>
                                <div className='icon'><ShengsuoSvg /></div>
                                <div className='name'>索</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() =>
                                activeCtrl(STRUCTURE_SUB_CONTROL.ADDSGRIDPOINTCONTROL.name, STRUCTURE_CTRL_TYPE.ADD_SGRIDPOINT)}>
                                <div className='icon'><DianjiedianSvg /></div>
                                <div className='name'>节点</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><HanfengSvg /></div>
                                <div className='name'>焊缝</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><MaodingSvg /></div>
                                <div className='name'>铆钉</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><LuoshuanSvg /></div>
                                <div className='name'>螺栓</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><JiajingbanSvg /></div>
                                <div className='name'>加劲板</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><HezaigongkuangSvg /></div>
                                <div className='name'>荷载工况</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><HezaizuheSvg /></div>
                                <div className='name'>荷载组合</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><JizhonghezaiSvg /></div>
                                <div className='name'>集中荷载</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><XianhezaiSvg /></div>
                                <div className='name'>线荷载</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><MianhezaiSvg /></div>
                                <div className='name'>面荷载</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><YueshuSvg /></div>
                                <div className='name'>约束</div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><TianjiaSvg /></div>
                                <div className='name'>添加</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ShuchuSvg /></div>
                                <div className='name'>删除</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><JisuanxuanxingSvg /></div>
                                <div className='name'>计算选型</div>
                            </div>
                            <div className='ope-item name5 disabled' onClick={() => { }}>
                                <div className='icon'><QiujieqixuanxingSvg /></div>
                                <div className='name'>求解器选型</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ChaxunSvg /></div>
                                <div className='name'>查询</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><XianshiSvg /></div>
                                <div className='name'>显示</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><GuifanjiaoyanSvg /></div>
                                <div className='name'>规范校验</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ShanchuSvg /></div>
                                <div className='name'>输出</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><CailiaobiaoSvg /></div>
                                <div className='name'>材料表</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><HezaibiaoSvg /></div>
                                <div className='name'>荷载表</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><LingpeijianbiaoSvg /></div>
                                <div className='name'>零配件表</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.section, MAJOR.STRUCTURE) }}>
                                <div className='icon'><SectionSvg /></div>
                                <div className='name'>截面</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.material, MAJOR.STRUCTURE) }}>
                                <div className='icon'><MaterialSvg /></div>
                                <div className='name'>材料</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}